// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","btn_wrapper":"O0LPK5","AniFadeIn":"ADLFgL","AniFadeOut":"XhZJr0","AniRotate":"_8r1UXB","AniPlaceholderFadeOut":"qfAMVH"};